exports = module.exports = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label[data-v-2f76304a]{display:inline-block;font-size:14px;text-align:right;padding-right:12px;box-sizing:border-box;vertical-align:top}.label[data-v-2f76304a] .el-icon--right{margin-left:2px}.el-dropdown[data-v-2f76304a]{color:#2c3e50}.el-dropdown-link[data-v-2f76304a]{display:inline-block;font-size:14px;text-align:right;padding-right:12px;box-sizing:border-box;vertical-align:top}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f76304a","scoped":true,"hasInlineConfig":false}!./node_modules/_sass-loader@7.3.1@sass-loader/dist/cjs.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./UI/Label/index.vue
// module id = 648
// module chunks = 0